<template>
    <div>
        <BarChart v-if="show_graphs" :options="chartData" @click="getDetails"/>
        <Spin size="large" fix v-if="loading"></Spin>
        <Row v-show="displayTable">
            <vs-collapse accordion>
                <!-- Tabela com a lista de registro creditados -->
                <vs-collapse-item v-if="comissoes_recebidas_data_perc.length>0">
                    <div slot="header">
                        <div class="flex space-between">
                            <div class="vx-col px-3 sm:w-1/2">
                                Recebidos na empresa
                            </div>
                            <div class="vx-col px-3 sm:w-1/2 text-right">
                                <b class="text-primary">{{computeTotalItem(comissoes_recebidas_data_perc)}}</b>
                            </div>
                        </div>
                    </div>
                    <Table :columns="comissoes_recebidas_cols_perc" :data="comissoes_recebidas_data_perc" :loading="loadingTable" class="comissoes"></Table>
                    <div class="relative">
                        <Table ref="tabela" :columns="comissoes_recebidas_cols" :data="comissoes_recebidas_data" :loading="loadingTable" class="comissoes"></Table>
                    </div>
                </vs-collapse-item>

                <!-- Tabela com a lista de registro recebidos em mãos-->
                <vs-collapse-item v-if="comissoes_em_maos_data_perc.length>0">
                    <div slot="header">
                        <div class="flex space-between">
                            <div class="vx-col px-3 sm:w-1/2">
                                Recebidos em mãos
                            </div>
                            <div class="vx-col px-3 sm:w-1/2 text-right">
                                <b class="text-primary">{{computeTotalItem(comissoes_em_maos_data_perc)}}</b>
                            </div>
                        </div>
                    </div>
                    <Table :columns="comissoes_em_maos_cols_perc" :data="comissoes_em_maos_data_perc" :loading="loadingTable"
                        class="comissoes"></Table>
                    <div class="relative">
                        <Table :columns="comissoes_em_maos_cols" :data="comissoes_em_maos_data" :loading="loadingTable" class="comissoes"></Table>
                    </div>
                </vs-collapse-item>

                <!-- Tabela com a lista de registro a ser creditados no mes seguinte-->
                <vs-collapse-item v-if="comissoes_creditadas_data_perc.length>0">
                    <div slot="header">
                        <div class="flex space-between">
                            <div class="vx-col px-3 sm:w-1/2">
                                A creditar
                            </div>
                            <div class="vx-col px-3 sm:w-1/2 text-right">
                                <b class="text-warning">{{computeTotalItem(comissoes_creditadas_data_perc)}}</b>
                            </div>
                        </div>
                    </div>
                    <Table :columns="comissoes_creditadas_cols_perc" :data="comissoes_creditadas_data_perc" :loading="loadingTable"
                        class="comissoes"></Table>
                    <div class="relative">
                        <Table :columns="comissoes_creditadas_cols" :data="comissoes_creditadas_data" :loading="loadingTable" class="comissoes"></Table>
                    </div>
                </vs-collapse-item>
            </vs-collapse>
        </Row>
    </div>
</template>

<style scoped>
    .comissoes {
        margin-top: 10px;
    }
</style>

<script>
    import accounting from "accounting";
    import {moment} from "@/helpers/utils.js";
    import {orderBy} from "lodash";
    import { revendaApi } from "@/api/axios";

    export default {
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
        },
        name: 'tabela-revendedores',
        props: {
            row: Object,
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        data() {
            return {
                chartData: {},
                loading:false,
                loadingTable: false,
                displayTable: false,
                show_graphs:true,
                comissoes_recebidas_cols_perc: [
                    {
                        title: ' '
                    },
                    {
                        title: 'Quantidade', key: 'qtde_mov',
                        align: 'right', width: 150,
                        sortable: true,
                    },
                    {
                        title: 'Recebido (R$)', key: 'total_recebido',
                        align: 'right', width: 170,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.total_recebido, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (%)', key: 'percentual',
                        align: 'right', width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.percentual, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Taxas (R$)', key: 'taxas',
                        align: 'right', width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.taxas, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (R$)', key: 'total_comissao',
                        sortable: true,
                        align: 'right', width: 165,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxas}" placement="left-start" content="${accounting.formatNumber(params.row.percentual, 2, ".", ",")}% (R$ ${accounting.formatNumber(params.row.total_recebido, 2, ".", ",")} - R$ ${accounting.formatNumber(params.row.taxas, 2, ".", ",")})">
                                        ${accounting.formatNumber(params.row.total_comissao, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.total_comissao, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: ' ',
                        width: 15,
                    },
                ],
                comissoes_em_maos_cols_perc: [
                    {
                        title: ' '
                    },
                    {
                        title: 'Quantidade', key: 'qtde_mov',
                        align: 'right', width: 150,
                        sortable: true,
                    },
                    {
                        title: 'Recebido (R$)', key: 'total_recebido',
                        align: 'right', width: 170,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.total_recebido, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (%)', key: 'percentual',
                        align: 'right', width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.percentual, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Taxas (R$)', key: 'taxas',
                        align: 'right', width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.taxas, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (R$)', key: 'total_comissao',
                        sortable: true,
                        align: 'right', width: 165,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxas}" placement="left-start" content="${accounting.formatNumber(params.row.percentual, 2, ".", ",")}% (R$ ${accounting.formatNumber(params.row.total_recebido, 2, ".", ",")} - R$ ${accounting.formatNumber(params.row.taxas, 2, ".", ",")})">
                                        ${accounting.formatNumber(params.row.total_comissao, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.total_comissao, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: ' ',
                        width: 15,
                    },
                ],
                comissoes_creditadas_cols_perc: [
                    {
                        title: ' '
                    },
                    {
                        title: 'Quantidade', key: 'qtde_mov',
                        align: 'right', width: 150,
                        sortable: true,
                    },
                    {
                        title: 'Creditar (R$)', key: 'total_recebido',
                        align: 'right', width: 170,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.total_recebido, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (%)', key: 'percentual',
                        align: 'right', width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.percentual, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Taxas (R$)', key: 'taxas',
                        align: 'right', width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.taxas, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (R$)', key: 'total_comissao',
                        sortable: true,
                        align: 'right', width: 165,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxas}" placement="left-start" content="${accounting.formatNumber(params.row.percentual, 2, ".", ",")}% (R$ ${accounting.formatNumber(params.row.total_recebido, 2, ".", ",")} - R$ ${accounting.formatNumber(params.row.taxas, 2, ".", ",")})">
                                        ${accounting.formatNumber(params.row.total_comissao, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.total_comissao, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: ' ',
                        width: 15,
                    },
                ],
                comissoes_recebidas_data_perc: [],
                comissoes_em_maos_data_perc: [],
                comissoes_creditadas_data_perc: [],
                comissoes_recebidas_cols: [
                    {
                        title: 'Data',
                        key: 'data_credito',
                        width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${moment(params.row.data_credito).format('DD/MM/YYYY')}`);
                        }
                    },
                    {
                        title: 'Id',
                        key: 'id_cliente',
                        width: 100,
                        align: 'right',
                        sortable: true,
                    },
                    {
                        title: 'Nome',
                        key: 'nome_cliente',
                        sortable: true,
                    },
                    {
                        title: 'Parcela (R$)',
                        key: 'parcela_valor',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.parcela_valor, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Recebido (R$)',
                        key: 'valor_recebido',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.valor_recebido, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (%)',
                        key: 'percentual_aplicado',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.percentual_aplicado, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Taxas (R$)',
                        key: 'taxa',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxa}" placement="top" content="Tipo: ${params.row.tipo_recebimento}">
                                        ${accounting.formatNumber(params.row.taxa, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.taxa, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: 'Comissão (R$)',
                        key: 'comissao',
                        align: 'right',
                        sortable: true,
                        width: 165,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxa}" placement="left-start" content="${accounting.formatNumber(params.row.percentual_aplicado, 2, ".", ",")}% (R$ ${accounting.formatNumber(params.row.valor_recebido, 2, ".", ",")} - R$ ${accounting.formatNumber(params.row.taxa, 2, ".", ",")})">
                                        ${accounting.formatNumber(params.row.comissao, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.comissao, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: ' ',
                        width: 15,
                    },
                ],
                comissoes_em_maos_cols: [
                    {
                        title: 'Data',
                        key: 'data_credito',
                        width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${moment(params.row.data_credito).format('DD/MM/YYYY')}`);
                        }
                    },
                    {
                        title: 'Id',
                        key: 'id_cliente',
                        width: 100,
                        align: 'right',
                        sortable: true,
                    },
                    {
                        title: 'Nome',
                        key: 'nome_cliente',
                        sortable: true,
                    },
                    {
                        title: 'Parcela (R$)',
                        key: 'parcela_valor',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.parcela_valor, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Recebido (R$)',
                        key: 'valor_recebido',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.valor_recebido, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (%)',
                        key: 'percentual_aplicado',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.percentual_aplicado, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Taxas (R$)',
                        key: 'taxa',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxa}" placement="top" content="Tipo: ${params.row.tipo_recebimento}">
                                        ${accounting.formatNumber(params.row.taxa, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.taxa, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: 'Comissão (R$)',
                        key: 'comissao',
                        align: 'right',
                        sortable: true,
                        width: 165,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxa}" placement="left-start" content="${accounting.formatNumber(params.row.percentual_aplicado, 2, ".", ",")}% (R$ ${accounting.formatNumber(params.row.valor_recebido, 2, ".", ",")} - R$ ${accounting.formatNumber(params.row.taxa, 2, ".", ",")})">
                                        ${accounting.formatNumber(params.row.comissao, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.comissao, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: ' ',
                        width: 15,
                    },
                ],
                comissoes_creditadas_cols: [
                    {
                        title: 'Data',
                        key: 'data_credito',
                        width: 160,
                        sortable: true,
                        render: (h, params) => {
                            return h('div', `${moment(params.row.data_credito).format('DD/MM/YYYY')}`);
                        }
                    },
                    {
                        title: 'Id',
                        key: 'id_cliente',
                        width: 100,
                        align: 'right',
                        sortable: true,
                    },
                    {
                        title: 'Nome',
                        key: 'nome_cliente',
                        sortable: true,
                    },
                    {
                        title: 'Parcela (R$)',
                        key: 'parcela_valor',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.parcela_valor, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Creditar (R$)',
                        key: 'valor_recebido',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.valor_recebido, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Comissão (%)',
                        key: 'percentual_aplicado',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h('div', `${accounting.formatNumber(params.row.percentual_aplicado, 2, ".", ",")}`);
                        }
                    },
                    {
                        title: 'Taxas (R$)',
                        key: 'taxa',
                        align: 'right',
                        sortable: true,
                        width: 160,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxa}" placement="top" content="Tipo: ${params.row.tipo_recebimento}">
                                        ${accounting.formatNumber(params.row.taxa, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.taxa, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: 'Comissão (R$)',
                        key: 'comissao',
                        align: 'right',
                        sortable: true,
                        width: 165,
                        render: (h, params) => {
                            return h({
                                template: `
                                    <Tooltip v-if="${params.row.taxa}" placement="left-start" content="${accounting.formatNumber(params.row.percentual_aplicado, 2, ".", ",")}% (R$ ${accounting.formatNumber(params.row.valor_recebido, 2, ".", ",")} - R$ ${accounting.formatNumber(params.row.taxa, 2, ".", ",")})">
                                        ${accounting.formatNumber(params.row.comissao, 2, ".", ",")}
                                    </Tooltip>
                                    <span v-else >${accounting.formatNumber(params.row.comissao, 2, ".", ",")}</span>`
                            });
                        }
                    },
                    {
                        title: ' ',
                        width: 15,
                    },
                ],
                comissoes_recebidas_data: [],
                comissoes_em_maos_data: [],
                comissoes_creditadas_data: [],
            }
        },
        methods: {
            exportData() {
                this.$refs.tabela.exportCsv({
                    filename: 'Tickets'
                })
            },
            getDetails(params) {
                if (params.selected) {
                    this.displayTable = false;
                    this.comissoes_recebidas_data = [];
                    this.comissoes_recebidas_data_perc = [];
                    this.comissoes_em_maos_data = [];
                    this.comissoes_em_maos_data_perc = [];
                    this.comissoes_creditadas_data = [];
                    this.comissoes_creditadas_data_perc = [];
                    return;
                }

                const chave = Object.keys(this.row)[params.dataIndex];
                const {id_pessoa, ano_mes} = this.row[chave];

                if (id_pessoa && ano_mes) {
                    this.displayTable = true;
                    this.getInfoMonth(id_pessoa, ano_mes);
                }
            },
            async getInfoMonth(id_pessoa, ano_mes) {
                this.loadingTable = true;
                try {
                    const [ano, mes] = ano_mes.split('_');
                    const URI = `comissoes/${id_pessoa}/detalhar/${ano}/${mes}`;
                    // busca todos registros no periodo
                    let {data} = await revendaApi.get(URI);
                    // mapea os dados de registros recebidos
                    this.comissoes_recebidas_data = data.recebido.map(dados => ({
                        ...dados,
                        percentual_aplicado: parseFloat(dados.percentual_aplicado),
                        valor_recebido: parseFloat(dados.valor_recebido || 0),
                        parcela_valor: parseFloat(dados.parcela_valor),
                        taxa: parseFloat(dados.taxa),
                        comissao: parseFloat(dados.lancamento_valor)
                    }));
                    // faz os calculos de comissao
                    let lista_recebidos_percentuais = data.recebido.reduce((carry, dados) => {
                        const key = dados.percentual_aplicado;
                        if (carry[key]) {
                            carry[key][`qtde_mov`]++;
                            carry[key][`total_recebido`] += parseFloat(dados.valor_recebido || 0);
                            carry[key][`taxas`] += parseFloat(dados.taxa);
                            carry[key][`total_comissao`] += parseFloat(dados.lancamento_valor);
                        } else {
                            carry[key] = {
                                percentual: parseFloat(dados.percentual_aplicado),
                                qtde_mov: 1,
                                total_recebido: parseFloat(dados.valor_recebido || 0),
                                taxas: parseFloat(dados.taxa || 0),
                                total_comissao: parseFloat(dados.lancamento_valor)
                            };
                        }
                        return carry;
                    }, {});
                    this.comissoes_recebidas_data_perc = orderBy(Object.values(lista_recebidos_percentuais), ["percentual"], ["asc"]);

                    // mapea os dados de registros em maos
                    this.comissoes_em_maos_data = data.recebido_em_maos.map(dados => ({
                        ...dados,
                        percentual_aplicado: parseFloat(dados.percentual_aplicado),
                        valor_recebido: parseFloat(dados.valor_recebido || 0),
                        parcela_valor: parseFloat(dados.parcela_valor),
                        taxa: parseFloat(dados.taxa),
                        comissao: parseFloat(dados.lancamento_valor) - parseFloat(dados.taxa)
                    }));
                    // faz os calculos de comissao
                    let lista_em_maos_percentuais = data.recebido_em_maos.reduce((carry, dados) => {
                        const key = dados.percentual_aplicado;
                        if (carry[key]) {
                            carry[key][`qtde_mov`]++;
                            carry[key][`total_recebido`] += parseFloat(dados.valor_recebido || 0);
                            carry[key][`taxas`] += parseFloat(dados.taxa);
                            carry[key][`total_comissao`] += parseFloat(dados.lancamento_valor);
                        } else {
                            carry[key] = {
                                percentual: parseFloat(dados.percentual_aplicado),
                                qtde_mov: 1,
                                total_recebido: parseFloat(dados.valor_recebido || 0),
                                taxas: parseFloat(dados.taxa || 0),
                                total_comissao: parseFloat(dados.lancamento_valor)
                            };
                        }
                        return carry;
                    }, {});
                    this.comissoes_em_maos_data_perc = orderBy(Object.values(lista_em_maos_percentuais), ["percentual"], ["asc"]);

                    // mapea os dados de registros creditadas
                    this.comissoes_creditadas_data = data.creditado.map(dados => ({
                        ...dados,
                        percentual_aplicado: parseFloat(dados.percentual_aplicado),
                        valor_recebido: parseFloat(dados.valor_recebido || 0),
                        parcela_valor: parseFloat(dados.parcela_valor),
                        taxa: parseFloat(dados.taxa),
                        comissao: parseFloat(dados.lancamento_valor) - parseFloat(dados.taxa)
                    }));
                    // faz os calculos de comissao
                    let lista_creditados_percentuais = data.creditado.reduce((carry, dados) => {
                        const key = dados.percentual_aplicado;
                        if (carry[key]) {
                            carry[key][`qtde_mov`]++;
                            carry[key][`total_recebido`] += parseFloat(dados.valor_recebido || 0);
                            carry[key][`taxas`] += parseFloat(dados.taxa);
                            carry[key][`total_comissao`] += parseFloat(dados.lancamento_valor);
                        } else {
                            carry[key] = {
                                percentual: parseFloat(dados.percentual_aplicado),
                                qtde_mov: 1,
                                total_recebido: parseFloat(dados.valor_recebido || 0),
                                taxas: parseFloat(dados.taxa || 0),
                                total_comissao: parseFloat(dados.lancamento_valor)
                            };
                        }
                        return carry;
                    }, {});
                    this.comissoes_creditadas_data_perc = orderBy(Object.values(lista_creditados_percentuais), ["percentual"], ["asc"]);

                } catch (ex) {
                    console.warn(ex);
                }
                this.loadingTable = false;
            },
            loadStats() {
                this.loading = true
                const data = this.row;
                const meses = Object.keys(data).map(key => moment(key, "YYYY_MM").format("MM/YYYY"));
                const comissoes = Object.values(data).map(comissao => comissao.total_comissao);

                this.chartData = {
                    tooltip: {
                        formatter: (param) => `${param.seriesName}<br />${param.marker} ${param.name}: R$ ${accounting.formatNumber(param.value, 2, ".", ",")}`
                    },
                    xAxis: {
                        data: meses,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50,
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value ? `R$ ${accounting.formatNumber(param.value, 2, ".", ",")}` : '',
                    },
                    series: [{
                        name: "Recebido",
                        type: 'bar',
                        color: "#4caf50",
                        data: comissoes,
                    }]
                }
                this.loading = false
            },
            computeTotalItem(item){
                let total = 0;
                if (item){
                    item.map(item =>{
                        total+=item.total_comissao
                    })
                }
                return accounting.formatNumber(total, 2, ".", ",")
            }
        },
        created() {
            this.loadStats()
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.displayTable = false
                    this.loadStats()
                }
            },
            download(){
                if(this.download) {
                    this.exportData()
                }
            },
            close(){
                if (this.close){
                    this.displayTable = false
                    this.show_graphs = false
                } else {
                    this.show_graphs = true
                }
            },
            displayTable(){
                this.$emit('download',this.displayTable)
            }
        }
    };
</script>
